import React from 'react';
import { Select, Space } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { AppLanguage, getLanguageOption, LANGUAGE_OPTIONS } from '../i18n';
import { useLanguage } from '../contexts/LanguageContext';

interface LanguageSelectProps {
  style?: React.CSSProperties;
  className?: string;
}

const LanguageSelect: React.FC<LanguageSelectProps> = ({ style, className }) => {
  const { language, setLanguage, t } = useLanguage();
  const current = getLanguageOption(language);

  const renderLanguageLabel = (flag: string, label: string) => (
    <Space size={6} align="center">
      <span className="language-select-flag" aria-hidden>
        {flag}
      </span>
      <span className="language-select-label">{label}</span>
    </Space>
  );

  return (
    <Select<AppLanguage>
      className={['language-select', className].filter(Boolean).join(' ')}
      data-i18n-ignore="true"
      value={language}
      onChange={setLanguage}
      style={style}
      aria-label={t('language')}
      suffixIcon={<GlobalOutlined className="language-select-globe" />}
      popupMatchSelectWidth={false}
      popupClassName="language-select-dropdown"
      dropdownStyle={{ minWidth: 148 }}
      dropdownRender={(menu) => <div data-i18n-ignore="true">{menu}</div>}
      options={LANGUAGE_OPTIONS.map((opt) => ({
        value: opt.value,
        label: opt.label,
        flag: opt.flag,
      }))}
      labelRender={() => renderLanguageLabel(current.flag, current.label)}
      optionRender={(option) =>
        renderLanguageLabel(option.data.flag as string, option.label as string)
      }
    />
  );
};

export default LanguageSelect;
